import React, {Suspense} from "react";
import "./app.scss";
import PropTypes from "prop-types";
import config from "./config";

import Loader from "./components/widgets/loader";

const StepForm = React.lazy(() => import("./containers/step/step.form"));
const Page = React.lazy(() => import("./containers/page/page"));
const Agent = React.lazy(() => import("./containers/agent.container"));
const FullPublicForm = React.lazy(() =>
    import("./containers/full.public/full.public.form")
);

class App extends React.Component {
    static propTypes = {
        component: PropTypes.string,
    };

    render() {
        const {component, ...rest} = this.props;

        const product = component.split(".")[component.split(".").length - 1];

        return (
            <div className="app">
                <Suspense fallback={<Loader/>}>
                    {config.form_urls.hasOwnProperty(component) ? (
                        <StepForm {...{product, ...rest}} />
                    ) : config.page_urls.hasOwnProperty(component) ? (
                        <Page {...{page: product, ...rest}} />
                    ) : config.full_public_form_urls.hasOwnProperty(component) ? (
                        <FullPublicForm {...{product, ...rest}} />
                    ) : (
                        <Agent/>
                    )}
                </Suspense>
            </div>
        );
    }
}

export default App;
